export default {
  roleTypes: state => state.roleTypes,
  doctors: state => state.doctors,
  admins: state => state.admins,
  labTechnicians: state => state.lab_technicians,
  nurses: state => state.nurses,
  medicalStaffForDropdown: state => state.medicalStaffForDropdown,
  operators: state => state.operators,
  allUsers: state => state.allUsers,
  linesOfWork: state => state.linesOfWork,
  linesOfWorkTypes: state => state.linesOfWorkTypes,
  directions: state => state.directions,
  directionsForDropdown: state => state.directionsForDropdown,
  directionsPerPage: state => state.directionsPerPage,
  directionsPerPageCount: state => state.directionsPerPageCount,
  directionSettings: state => state.directionSettings,
  departmentsPerPage: state => state.departmentsPerPage,
  departmentsPerPageCount: state => state.departmentsPerPageCount,
  departments: state => state.departments,
  integratorBranches: state => state.integratorBranches,
  userIntegratorBranches: state => state.userIntegratorBranches,
  userOfficePhoneNumbersPerPage: state => state.userOfficePhoneNumbersPerPage,
  userOfficePhoneNumbersPerPageCount: state => state.userOfficePhoneNumbersPerPageCount
}
